<template>
    <div>
        <!-- ADDRESS -->
        <span class="text-danger" v-if="hasError('address')">{{getError('address')}}</span>
        <address-input
          @change="handleAddressChange"
          :input-class="hasError('address') ? 'error' : ''"
          :address.sync="data.address"
          :placeholder="__t('shop.checkout.address')"
        />

        <span class="text-danger" v-if="hasError('country_code')">{{getError('country_code')}}</span>
        <div class="form-group">
          <select2
            style="width:100%;"
            :settings="{placeholder: __t('shop.checkout.country')}"
            v-model="data.country_code"
            :options="countrySelectOptions"
            class="form-control"
            @input="handleCountryChange"
          />
        </div>


        <span class="text-danger" v-if="hasError('city')">{{getError('city')}}</span>
        <div class="form-group">
          <label class="control-label"><span class="sr-only"> {{ __t('shop.checkout.city') }}</span>
              <input v-model="data.city" type="text" class="form-control" :placeholder="__t('shop.checkout.city')" @keyup="clearErrors">
          </label>
        </div>

        <span class="text-danger" v-if="hasError('postal_code')">{{getError('postal_code')}}</span>
        <div class="form-group">
           <label class="control-label"><span class="sr-only">{{ __t('shop.checkout.postal_code') }}</span>
          <input
            v-model="data.postal_code"
            type="text"
            class="form-control"
            :placeholder="__t('shop.checkout.postal_code')"
            @keyup="clearErrors"
            @blur="$emit('postal_code:blur',data.postal_code)"
            >
           </label>

        </div>

        <span class="text-danger" v-if="hasError('state_code')">{{getError('state_code')}}</span>
        <div class="form-group">

          <select2
            style="width:100%;"
            :settings="{placeholder: __t('shop.checkout.state')}"
            :options="countryStateSelectOptions"
            class="form-control"
            v-model="data.state_code"
            @input="handleStateChange"
          />
        </div>

        <div class="form-group">
          <input
            style="width:100%;"
            :placeholder="__t('shop.checkout.floor')"
            class="form-control"
            v-model="data.floor_number"
          >
        </div>

        <div class="form-group">
          <textarea
            style="width:100%;"
            :placeholder="__t('shop.checkout.notes')"
            class="form-control"
            v-model="data.notes">
          </textarea>
        </div>




    </div>
</template>
<script>

import select2 from '@/components/ui/select2';
import AddressInput from './common/address-input';

export default {
    components: {select2,AddressInput},
    data: function(){
        return {

        }
    },
    props:{
      errors: [Object,Array],
      data: Object,
      countries: Array,
      type: String,
    },
    computed:{
      countrySelectOptions(){
        return this.countries.map(c => ({id: c.code3, text: c.name}));
      },
      countryStateSelectOptions(){
        return this.countryStates.map(c => ({id: c.iso_code, text: c.name}));
      },
      country(){
        return this.countries.find(x => x.code3 == this.data.country_code);
      },
      countryStates(){
        if(this.country) return this.country.states;
        return this.countries.map(c => c.states).flat()
      },
      hasErrors(){
        return !this.$_.isEmpty(this.errors)
      },
    },
    methods:{
      handleCountryChange(event){
        this.$emit('country:change',event);
        this.clearErrors();
      },
      handleStateChange(event){
        this.$emit('state:change',event);
        this.clearErrors();
      },
      clearErrors(){
        if(this.hasErrors)
        this.$emit('clear-errors');
      },
      handleAddressChange(prediction){
        this.clearErrors();
        // this.data.details = prediction;
        this.$emit('address:change',prediction);
      },
      getError(field){
        if(!this.hasError(field)) return '';
        var checkField = this.type == 'billing' ? `billingAddress.${field}` : `shippingAddress.${field}`;
        return this.errors[checkField][0];
      },
      hasError(field){
        var checkField = this.type == 'billing' ? `billingAddress.${field}` : `shippingAddress.${field}`;
        return this.hasErrors && this.errors.hasOwnProperty(checkField);
      }
    },
    created(){

    }
}
</script>

<style>

  .select2-selection.select2-selection--single .select2-selection__placeholder{
    font-size: 15px;
    color: #b1b7ba;
  }
  .form-control{
  text-indent: 10px;
  }
</style>
